import { OptionType } from '../../types';

export const optionTypeToTranslationMap: { [key in OptionType]: string } = {
  bool: 'menu-option.switch',
  choice: 'menu-option.single-choice',
  multi_choice: 'menu-option.multi-choice',
};
